import { BaseModal } from "./Modal";

export { BaseModal };